import {
  CheckCircleOutline as CheckCircleOutlineIcon,
  ErrorOutline as ErrorOutlineIcon,
} from '@mui/icons-material';
import { Box, Tooltip } from '@mui/material';
import moment from 'moment';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { OrderStatusLabel, Timer } from 'components';
import { OrderStatus } from 'enums';
import { TranslationNamespace } from 'i18n';
import { PayinOrder } from 'types';

type Props = {
  order: PayinOrder;
};

export const OrderStatusColumn: React.FC<Props> = ({ order }) => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.order_automation',
  });

  const showTimer = useMemo(
    () =>
      order.statusTimeoutAt &&
      order.statusAt &&
      [
        OrderStatus.New,
        OrderStatus.TraderConfirm,
        OrderStatus.CustomerConfirm,
        OrderStatus.WaitingConfirmation,
        OrderStatus.HoldCompleted,
      ].includes(order.status),
    [order.status, order.statusAt, order.statusTimeoutAt],
  );

  return (
    <div>
      {showTimer && <Timer endTime={moment(order.statusTimeoutAt).toDate()} />}
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <OrderStatusLabel status={order.status} />
        {order.confirmedByAutomation && (
          <Box ml={2}>
            <Tooltip title={t('confirmed')}>
              <CheckCircleOutlineIcon color="success" />
            </Tooltip>
          </Box>
        )}
        {order.conflictedByAutomation && (
          <Box ml={2}>
            <Tooltip title={t('conflict')}>
              <ErrorOutlineIcon color="warning" />
            </Tooltip>
          </Box>
        )}
      </Box>
    </div>
  );
};
